angular.module('WTG.U',[]).factory('U',function($rootScope,$timeout) {

 var U = {

  time: {
   epoch: {
    interact: +new Date(Date.UTC(2015,0,1)),
    unix: +new Date(Date.UTC(1970,0,1))
   },
   from_interact_epoch: function U_time_from_interact_epoch(interactime) {
    return new Date(this.epoch.interact + +interactime*1000);
   },
   from_unix_epoch: function U_time_from_unix_epoch(unixtime) {
    return new Date(this.epoch.unix + +unixtime*1000);
   }
  },

  ng: {
   /* {
    *  evt: event name
    *  assess: (evt).fn(args) returning true if this is the event we've been waiting for
    *  trigger: fn() to execute that will trigger whatever we're waiting for
    *  timeout: time before we give up in ms
    *  scope: scope to subscribe on
    * }
    * cb: callback executed upon completion (evt).fn(err,args)
    */
   once$on: function once$on(p,cb) {
    var scope = p.scope||$rootScope;
    var unsub = scope.$on(p.evt,function() {
     var args = Array.from(arguments);
     var evt = args.shift();
     if(p.assess && !p.assess.apply(evt,args)) return;
     if(unsub) unsub();
     if(to) $timeout.cancel(to);
     scope.$applyAsync(function() {
      cb.apply(evt,[null].concat(args));
     });
    });
    if(p.trigger) p.trigger();
    var to = p.timeout && $timeout(function() {
     if(unsub) unsub();
     if(to) $timeout.cancel(to);
     cb(Object.assign(new Error("timed out waiting for event"),{reason:"timeout"}));
    },p.timeout);
   }
  },

  /* TODO: ideally we should avoid the copy of identical code in util */
  is_valid_mobile: function U_is_valid_mobile(n) {
   return /^\+\d{10,13}$/.test(n);
  },
  is_valid_email: function U_is_valid_email(mail) {
   return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(mail));
  }

 };

 return U;
});
